import { render, staticRenderFns } from "./SystemPermissionGroupManageDetailBySystem.vue?vue&type=template&id=675daabf&scoped=true"
import script from "./SystemPermissionGroupManageDetailBySystem.vue?vue&type=script&lang=js"
export * from "./SystemPermissionGroupManageDetailBySystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675daabf",
  null
  
)

export default component.exports